import React, { useState, useCallback } from 'react';
import UAEFDLDataManagementHeader from './UAEFDLDataManagementHeader';
import UAEFDLDataManagementTable from './UAEFDLDataManagementTable';
import './UAEFDLDataManagement.scss';

const UAEFDLDataManagement = () => {
  const [filters, setFilters] = useState({
    periodFrom: '2025-01-01',
    periodTo: '2025-12-31',
    scope: 'Scope 1',
    category: [],
    businessUnitIds: [],
    period: '2025-01-01'
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const [tableEdits, setTableEdits] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentView, setCurrentView] = useState('combined');
  
  const [tableData, setTableData] = useState({
    tableRows: [],
    branchNames: [],
    editableData: {},
    validationErrors: {}
  });
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [clearEditableData, setClearEditableData] = useState(false);
  const [refreshTimestamp, setRefreshTimestamp] = useState(Date.now());

  const handleEditModeChange = useCallback((edit) => {
    setIsEditMode(edit);
    if (!edit) {
      setTableEdits({});
      setHasChanges(false);
      setTableData(prev => ({
        ...prev,
        editableData: {}
      }));
    }
  }, []);

  const handleTableDataChange = useCallback((edits) => {
    setTableEdits(edits);
    
    const hasActualChanges = Object.keys(edits).some(rowKey => {
      const rowData = edits[rowKey];
      const hasRowChanges = Object.keys(rowData).some(columnKey => {
        const value = rowData[columnKey];
        const isValidValue = value !== undefined && value !== null;
        const isUOMChange = columnKey.endsWith('_uom') && value !== undefined && value !== null;
        return isValidValue || isUOMChange;
      });
      return hasRowChanges;
    });
    
    setHasChanges(hasActualChanges);
    
    setTableData(prev => ({
      ...prev,
      editableData: edits
    }));
  }, [tableEdits]);

  const handleTableDataUpdate = useCallback((data) => {
    setTableData(data);
    const hasErrors = data.validationErrors && Object.keys(data.validationErrors).length > 0;
    setHasValidationErrors(hasErrors);
  }, []);

  const handleSaveData = useCallback((clearedEditableData = null) => {
    if (clearedEditableData !== null) {
      setTableEdits(clearedEditableData);
      setHasChanges(false);
      setTableData(prev => ({
        ...prev,
        editableData: clearedEditableData
      }));
    }
  }, []);

  const handleClearEditableData = useCallback(() => {
    setClearEditableData(true);
    setRefreshTimestamp(Date.now());
    setTimeout(() => {
      setClearEditableData(false);
    }, 100);
  }, []);

  const handleSearchChange = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  const handleViewChange = useCallback((view) => {
    setCurrentView(view);
  }, []);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  return (
    <div className="ghg-emission-data-management">
      <UAEFDLDataManagementHeader 
        onFilterChange={handleFilterChange} 
        onEditModeChange={handleEditModeChange}
        onSaveData={handleSaveData}
        isEditMode={isEditMode}
        hasChanges={hasChanges}
        onSearchChange={handleSearchChange}
        onViewChange={handleViewChange}
        editableData={tableData.editableData}
        tableRows={tableData.tableRows}
        branchNames={tableData.branchNames}
        tableEdits={tableEdits}
        tableData={tableData}
        onClearEditableData={handleClearEditableData}
        hasValidationErrors={hasValidationErrors}
      />
      <UAEFDLDataManagementTable 
        filters={filters} 
        isEditMode={isEditMode}
        onDataChange={handleTableDataChange}
        searchTerm={searchTerm}
        currentView={currentView}
        onTableDataUpdate={handleTableDataUpdate}
        clearEditableData={clearEditableData}
        refreshTimestamp={refreshTimestamp}
      />
    </div>
  );
};

export default UAEFDLDataManagement;
